import React from 'react';

/**
 * Standard error banner on the `.admin-banner-error` recipe — swap this in for any
 * ad-hoc "border-red-500/35 bg-red-500/10 text-red-300" div so every screen's error
 * state reads as one system instead of a dozen slightly-different reds.
 */
export function ErrorBanner({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`admin-banner-error ${className}`}>{children}</div>;
}
